import { render, staticRenderFns } from "./detail.html?vue&type=template&id=69784102&scoped=true&"
import script from "./DetailTop.vue?vue&type=script&lang=js&"
export * from "./DetailTop.vue?vue&type=script&lang=js&"
import style0 from "./DetailTop.vue?vue&type=style&index=0&id=69784102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69784102",
  null
  
)

export default component.exports